<div class="col-12">
  <h5 class="fw-bold mt-3">Sessioni</h5>

  @if (eventDaysSchedule().length > 0) {
    @for (day of eventDaysSchedule(); track day.dateLabel) {
      <h6 class="mt-3 mb-2 text-capitalize">{{ day.dateLabel }}</h6>

      @if (day.sessions.length > 0) {
        <ul class="list-group mb-3">
          @for (session of day.sessions; track session.id) {
            <li class="list-group-item">
              <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2 gap-sm-2">
                <div class="flex-grow-1">
                  <strong>Dalle {{ session.startTime | date:'HH:mm' }}</strong>
                  <span class="mx-2">|</span>
                  <strong>Alle:
                    {{ session.endTime ? (session.endTime | date:'HH:mm') : 'In corso' }}</strong>
                  <span class="mx-2">|</span>
                  <span class="badge"
                        [ngClass]="isSessionFull(session) ? 'bg-danger' : 'bg-info'">
                                <i class="bi bi-people-fill"></i>
                    {{ getSessionPlayerCount(session) }}/{{ getEffectiveMaxPlayers(session) }}
                              </span>
                </div>
                <div class="d-flex flex-wrap gap-2 align-items-center">
                  @if (canManage(session)) {
                    <button class="btn btn-warning btn-sm" (click)="onEdit(session.id)">
                      <i class="bi bi-pencil me-1" aria-hidden="true"></i>Modifica
                    </button>
                    <button class="btn btn-danger btn-sm" (click)="onDelete(session.id)">
                      <i class="bi bi-trash me-1" aria-hidden="true"></i>Elimina
                    </button>
                  }
                  @if (canCheckIn(session)) {
                    <button class="btn btn-success btn-sm" (click)="onCheckIn(session.id)">
                      <i class="bi bi-check-circle me-1" aria-hidden="true"></i>Check-in
                    </button>
                  } @else if (isCheckedIn(session)) {
                    <span class="badge bg-success">
                      <i class="bi bi-check-circle-fill me-1" aria-hidden="true"></i>Check-in effettuato
                    </span>
                    @if (canCheckOut(session)) {
                      <button class="btn btn-warning btn-sm" (click)="onCheckOut(session.id)">
                        <i class="bi bi-box-arrow-right me-1" aria-hidden="true"></i>Check-out
                      </button>
                    }
                  } @else if (!isUserApproved()) {
                    <span class="badge bg-warning text-dark">
                      <i class="bi bi-hourglass-split me-1" aria-hidden="true"></i>In attesa
                    </span>
                  }
                </div>
              </div>
            </li>
          }
        </ul>
      } @else {
        <p class="small text-muted fst-italic mb-3">Nessuna sessione registrata per questa giornata.</p>
      }

      @if (canCreateSession() && tableId && !showForm) {
          @if (addingForDate()?.getTime() === day.date.getTime()) {
            <app-quick-session-stepper
              [initialTime]="quickStepperInitialTime()"
              (confirm)="onQuickAddSessionConfirm(day.date, $event)"
              (cancel)="onQuickAddCancel()">
            </app-quick-session-stepper>
          } @else {
            <button class="btn btn-outline-primary btn-sm w-100 mt-2" (click)="onQuickAddSession(day.date, day.sessions)">
               <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Aggiungi sessione rapida
            </button>
          }
      }
    }
  } @else {
    <p class="small text-muted fst-italic mb-3">Nessuna sessione registrata per questo tavolo.</p>
  }

  @if (canCreateSession() && tableId) {
    @if (showForm) {
      <app-game-session-form
        [tableId]="tableId"
        [showOverride]="showOverride"
        [requireOverride]="requireOverride"
        [sessionToEdit]="editingSession"
        [title]="isEditing ? 'Modifica sessione' : 'Aggiungi sessione'"
        [submitLabel]="isEditing ? 'Aggiorna sessione' : 'Crea sessione'"
        [defaultStartDate]="table.event?.startDate"
        [eventStartDate]="table.event?.startDate"
        [eventEndDate]="table.event?.endDate"
        (formSubmit)="onSessionSubmit($event)"
        (cancel)="onCancel()">
      </app-game-session-form>
    } @else {
      <div class="text-center">
        <button class="btn btn-primary btn-sm mt-2" (click)="onAddNewSession()">
          <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Sessione
        </button>
      </div>
    }
  }
</div>
